
import * as React from 'react';
import { useRef } from 'react';
import { useInViewport } from 'react-in-viewport';
import Skeleton from 'react-loading-skeleton';

import Checkers from '../../../../../../helpers/class/Checkers';

export default function Themes ( props ) {
  const config = { disconnectOnLeave: false };
  const options = {  };
  const myRef = useRef();
  const {
    inViewport
  } = useInViewport(
    myRef,
    options,
    config,
    props
  );

  let viewPortResult = null;
  if ( !inViewport ) {
    viewPortResult =
            <div ref={myRef}>
              <Skeleton className="col-12 b-rad-md" height={30} />
            </div>
    ;
  } else {
      viewPortResult =
          <div className="row w-100 m-0">
              <div className="col-12">
                  {
                      props.themes.map((theme, index) => (
                          <span key={'property-themes-' + index} className="btn btn-default btn-cons btn-rounded btn-notification-style m-b-10 active">
                            {
                                Checkers.isValidString(theme.theme_fa_icon) ?
                                    <i className={theme.theme_fa_icon + '\ m-r-10'}/>
                                    :
                                    <i className={'fa-solid fa-hashtag m-r-10'}/>
                            }
                            {theme.theme_title}
                          </span>
                      ))
                  }
                  {/*  <p># Sea view</span><span*/}
                  {/*    className="btn btn-default btn-cons btn-rounded btn-notification-style m-b-10 active"># Luxury</span><span*/}
                  {/*    className="btn btn-default btn-cons btn-rounded btn-notification-style m-b-10 active"># Beachfront</span>*/}
                  {/*</p>*/}
              </div>
          </div>

      ;
  }

  return (
    Checkers.isValidArray( props.themes ) &&
      <div ref={myRef} id="pro_detail_themes" className="pb-5">
        {/*<div className="row w-100 m-0">*/}
          { viewPortResult }
        {/*</div>*/}
      </div>
  )
}
